import { createTheme } from "@mui/material/styles";
import { APP_MUI_THEME } from "./theme-app-config";

const theme = createTheme(APP_MUI_THEME);

export default theme;
